var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHat3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6517 7.46728L16.2462 13.7049L16.2537 13.7833C16.2949 14.2157 16.6625 14.5312 17.0746 14.4879C17.4868 14.4447 17.7875 14.0591 17.7463 13.6267L17.4339 10.3496C20.182 11.2845 22 12.9079 22 14.7541C22 17.6513 17.5228 20 12 20C6.47715 20 2 17.6513 2 14.7541C2 12.9079 3.81799 11.2845 6.56607 10.3496L6.25372 13.6267C6.21251 14.0591 6.51321 14.4447 6.92537 14.4879C7.33753 14.5312 7.70506 14.2157 7.74628 13.7833L7.75372 13.7049L8.34825 7.46729C8.53585 5.49895 10.1145 4 12 4C13.8854 4 15.4641 5.49895 15.6517 7.46728Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat3);
export default __webpack_public_path__ + "static/media/hat-3.4cda4d880a27b3c6f5f01235909ab235.svg";
export { ForwardRef as ReactComponent };